<template lang='pug'>
div.tw-flex.tw-flew-wrap(class="emd:tw-gap-3")
	div.tw-flex.tw-justify-around(class="tw-basis-6/12 emd:tw-gap-2 emd:tw-flex-col")
		div.tw-flex.tw-flex-col
			span.tw-font-light {{$t('common.passenger', 0)}} {{ passengerK + 1 }}
			span.tw-font-medium {{passenger.data.name}} {{passenger.data.surname}}
		div.tw-flex.tw-flex-col
			span.tw-font-light {{$t('dialogs.passengers_summary.offer_service', 'Offerta / Servizio')}}
			span.tw-font-normal {{offersAndService}}
	div.tw-flex.tw-justify-around(class="tw-basis-6/12 emd:tw-flex-col")
		div.tw-flex.tw-flex-col
			span.tw-font-light {{$t('dialogs.passengers_summary.wagon', 'Carrozza - Sedile')}}
			span.tw-font-normal {{seatSelection}}

		div.tw-flex.tw-content-center.tw-gap-4(v-if="hasADiscount")
			div.tw-relative
				div.line(v-if="disconutedPrice")
				div.tw-flex.tw-flex-col
					span.tw-font-light(:class="disconutedPrice ? 'discounted' : ''") {{$t('dialogs.passengers_summary.price', 'Prezzo')}}
					span.tw-font-medium(:class="disconutedPrice ? 'discounted' : ''") {{price}}
			div.tw-flex.tw-flex-col.tw-self-center
				span(v-if="disconutedPrice") =>
				span(v-else) &nbsp; &nbsp; &nbsp;
			div.tw-flex.tw-flex-col(:class="disconutedPrice ? '' : 'tw-w-[80px]'")
				span.tw-font-normal.tw-text-green-700(v-if="disconutedPrice") {{$t('sale.discount_code.discounted', 'Scontato')}}
				span.tw-font-medium.tw-text-xl.tw-text-green-700(v-if="disconutedPrice") {{disconutedPrice}}
		div.tw-flex.tw-flex-col(v-else)
			span.tw-font-light {{$t('dialogs.passengers_summary.price', 'Prezzo')}}
			span.tw-font-medium {{price}}
</template>

<script setup>
import {computed, inject, onMounted, shallowRef} from "vue";
import {useBookingStore} from "@/stores/booking";
import {printCurrencyValue} from "@/common-scripts/utilities";
import {useI18n} from "vue-i18n";


const i18n = useI18n();
const emit = defineEmits(['clicked']);
const props = defineProps({
	passenger: Object,
	passengerK: Number,
	trainId: String,
	travelSolution: Object,
	travelType: String
});
const bookingStore = useBookingStore();
const price = shallowRef(null);
const offersAndService = shallowRef(null);
const seatSelection = shallowRef(null);
const disconutedPrice = shallowRef(null);
const servicesMap = inject('servicesMap');
const passengersSelectionMap = inject('passengersSelectionMap');
const hasADiscount = inject('hasADiscount');



onMounted(() => {
	for (let offXmlId in props.travelSolution.offeredServices) {
		if (!Object.hasOwnProperty.call(props.travelSolution.offeredServices, offXmlId)) continue;
		const offeredService = props.travelSolution.offeredServices[offXmlId];

		if (offeredService.nodeId !== props.trainId) continue;
		if (offeredService.travellerXmlId !== props.passenger.data.xmlId) continue;
		if (93 == offeredService.offerId) continue;

		if (!offeredService.can_select_seatmap) seatSelection.value = i18n.t('dialogs.passengers_summary.not_selectable', 'Non selezionabile');
		if (hasADiscount && offeredService.original.attributes && 'ORIGINAL_AMOUNT' == offeredService.original.attributes.name &&
				parseFloat(offeredService.original.attributes.value) != parseFloat(offeredService.price.amount)) {

			price.value = printCurrencyValue(parseFloat(offeredService.original.attributes.value), offeredService.price.currency);
			disconutedPrice.value = printCurrencyValue(parseFloat(offeredService.price.amount), offeredService.price.currency);
		} else {
			price.value = printCurrencyValue(parseFloat(offeredService.price.amount), offeredService.price.currency);
		}
		offersAndService.value = servicesMap.offers[offeredService.offerId].display_name;
		offersAndService.value += ' / ' + servicesMap.catalog_services[offeredService.catalogServiceId].display_name;
	}

	if (!seatSelection.value) {
		const seatSelTmp = 'return' == props.travelType ? bookingStore.returnTravel.seats.selection : bookingStore.forwardTravel.seats.selection;

		if (!seatSelTmp[props.trainId]) {
			seatSelection.value = i18n.t('dialogs.passengers_summary.not_selected', 'Non selezionato');
		} else {
			const travellerXmlId = props.passenger.data.xmlId;

			for (const passengerT of seatSelTmp[props.trainId]) {
				if (passengerT.travellerXmlId != travellerXmlId) continue;
				seatSelection.value = passengerT.wagon + ' - ' + passengerT.seatToShow;
			}
		}
	}
});
</script>
<style scoped>
.discounted {
	color: rgba(22, 36, 80, 0.5);
}
.background {
	background-color: #BCBCBC;
	width: 100px;
	height: 50px;
	padding: 0;
	margin: 0
}

.line {
	width: 80px;
	height: 40px;
	border-bottom: 1px solid rgb(22, 36, 80);
	-webkit-transform: translateY(20px) translateX(5px) rotate(-26deg);
	position: absolute;
	top: -33px;
	left: -26px;
}
</style>